import { useState } from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { DashboardLangProvider } from "@/context/DashboardLangContext";
import { ConfirmProvider } from "@/components/ui/ConfirmDialog";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

/**
 * Responsive layout:
 *   ≥ lg (1024px): sidebar docked, can be collapsed to icons.
 *   <  lg:         sidebar off-canvas drawer, toggled by the TopBar
 *                  hamburger. Scrim dims and closes on tap.
 */
export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <DashboardLangProvider>
      <ConfirmProvider>
      <div className="flex h-screen bg-cream overflow-hidden">
        <Sidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed(!collapsed)}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />
        {mobileOpen && (
          <div
            className="fixed inset-0 z-30 bg-black/40 lg:hidden"
            onClick={() => setMobileOpen(false)}
            aria-label="Close navigation"
          />
        )}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <TopBar onMobileMenuOpen={() => setMobileOpen(true)} />
          <main className="flex-1 overflow-y-auto p-4 sm:p-6">
            {children}
          </main>
        </div>
      </div>
      </ConfirmProvider>
    </DashboardLangProvider>
  );
}
